//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../../World/Az/Header";
//Install
import Footer from "../../../../World/Az/Footer";
//Install
import M597I5 from "../../../../../Media/Image/030.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Orta Gərginlik Təsisləri : Temas Elektrik Müqaviləsi"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik, Davamlı və Etibarlı Enerji Xidmətləri ilə Hər Toxunuş Gələcəyə Dəyər Qatar."
        //Element
        let URL = "https://temaselektrik.com/az/orta-gerginlik-tesisleri"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Orta Gərginlik Təsisləri"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Orta ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Gərginlik "
                                        ),
                                        //Element
                                        "Təsisləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "1998-ci ildə İstanbulda təsis edilmiş Temas Elektrik Təchizat, təsis edildiyi gündən bu yana göstərdiyi uğur və davamlılıqla sektorda tanınan bir şirkət olmuşdur.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "2012-ci ildə fəaliyyətə başlayan Orta Gərginlik şöbəmiz qazandığı təcrübə və keyfiyyət standartları ilə orta və yüksək gərginlik qurğularında sektorun etibarlı həll tərəfdaşı mövqeyini qazandı."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Transformator Mərkəzi Quraşdırılması: Yeni qurulacaq transformator obyektlərində, Orta Gərginlik Şəbəkə Bağlantı Nöqtəsindən Aşağı Gərginlik Çıxış Panelinə qədər bütün yüksək gərginlik avadanlıqlarının açar təslim quraşdırılması və montajı həyata keçirilir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "ENH Tətbiqləri: 10 kV ilə 36 kV arasındakı bütün paylama şəbəkələrində, dəmir və ya beton dirəklərdən istifadə edilərək həyata keçirilən hava xətti tətbiqləri texniki komandamız tərəfindən tam və təhlükəsiz şəkildə tamamlanır."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Aşağı Struktur Tətbiqləri: Orta və Aşağı Gərginlik infrastrukturları, tranşe və kabelləmə işləri ilə yeraltı şəbəkə layihələri beynəlxalq standartlara uyğun şəkildə həyata keçirilir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "İnkişaf edən dünyada enerji və enerji infrastrukturu getdikcə daha vacib olur. Davamlı, keyfiyyətli və fasiləsiz enerji üçün transformator və elektrik qurğularının baxımı böyük əhəmiyyət kəsb edir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik; enerji sistemlərinin etibarlılığını təmin etmək üçün mütəmadi baxım və təmir işlərini zəruri texniki avadanlıq və təcrübəli komandası ilə həyata keçirir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Transformator Mərkəzi"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "1. Bina Tipli Transformator Mərkəzləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "2. Beton Kabin Tipli Transformator Mərkəzləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "3. Dirək Tipli Transformator Mərkəzləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "4. Yeraltı Kabin Tipli Transformator Mərkəzləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Transformator Baxım və Təmir Xidmətləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "1. Transformator Yağı Dielektrik Testi"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "2. Transformator Yağı Filtrləmə İşləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "3. İzolyasiya Testi"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "4. Termal Kamera ilə İstilik Yoxlaması"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "5. Kəsici və Ayırıcı Yoxlamaları"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "6. İdarəetmə Sistemi Testləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "7. Transformator Mərkəzi Baxımı"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Məsləhət və Mühəndislik Xidmətləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "1. Yüksək Gərginlik İstismar Məsuliyyəti"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "2. Rəsmi və Texniki Məsləhət Xidməti"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "3. Məsləhət Xidmətləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "4. Layihələndirmə və Mühəndislik Xidmətləri"
                                    ),
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Orta Gərginlik Təsisləri", title: "Orta Gərginlik Təsisləri", src: M597I5, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;